import { InjectionToken, Type } from '@angular/core';

export interface DataTestDialog {}

export const DATA_TEST_DIALOG_COMPONENT = new InjectionToken<Type<DataTestDialog>>('Data Test Dialog Component');
